import { useState } from 'react';
import ConfigurableModal from '../../../../common/ConfigurableModal/ConfigurableModal';

interface UnsavedChangesModalProps {
    isOpen: boolean;
    onClose: () => void;
    onCloseWithoutSaving: () => void;
    onSaveChanges: () => Promise<void>;
}

const UnsavedChangesModal = ({ isOpen, onClose, onCloseWithoutSaving, onSaveChanges }: UnsavedChangesModalProps) => {
    const [isSaving, setIsSaving] = useState(false);

    const handleSaveChanges = async () => {
        setIsSaving(true);
        try {
            await onSaveChanges();
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <ConfigurableModal
            isOpen={isOpen}
            onClose={onClose}
            heading="Unsaved Changes"
            message="Are you sure you want to leave without saving your changes?"
            primaryButton={{
                label: 'Save Changes',
                onClick: handleSaveChanges,
                disabled: isSaving,
                style: { backgroundColor: '#6021B3' },
            }}
            secondaryButton={{
                label: 'Close without Saving',
                onClick: onCloseWithoutSaving,
            }}
        />
    );
};

export default UnsavedChangesModal;
